module.exports = __webpack_public_path__ + "static/media/gabinete.d51b7104.png";